import { Funcoes } from './utils';


function ok() {
    return { ok: true, msg: null };
}


function erro(msg, prefixo = '') {
    return { ok: false, msg: prefixo ? `${prefixo}: ${msg}` : msg };
}


function obrigatorio(valor, mensagem = 'Campo não informado', prefixo = '') {
    if (valor === null || valor === undefined) {
        return erro(mensagem, prefixo);
    }

    if (typeof valor === 'string' && valor.trim() === '') {
        return erro(mensagem, prefixo);
    }

    return ok();
}


function texto(valor, mensagem = 'Texto não informado', prefixo = '') {
    if (!valor || String(valor).trim() === '') {
        return erro(mensagem, prefixo);
    }

    return ok();
}


function numeroPositivo(valor, mensagem = 'Valor inválido', prefixo = '') {
    if (valor === null || valor === undefined || valor === '') {
        return erro(mensagem, prefixo);
    }

    if (Number(valor) < 1) {
        return erro(mensagem, prefixo);
    }

    return ok();
}


function lista(valor, mensagem = 'Nenhum item informado', prefixo = '') {
    if (!Array.isArray(valor) || valor.length === 0) {
        return erro(mensagem, prefixo);
    }

    return ok();
}


function id(obj, msg = 'Necessário selecionar um registro', prefixo = '') {
    if (Funcoes.getId(obj) < 1) {
        return erro(msg, prefixo);
    }
    return ok();
}


function cNPJ(cnpj, prefixo = '') {
    if (!cnpj) return erro('CNPJ não informado', prefixo);

    const cleaned = cnpj.replace(/\D/g, '');
    if (cleaned.length !== 14) return erro('CNPJ deve conter 14 dígitos', prefixo);
    if (/^(\d)\1{13}$/.test(cleaned)) return erro('CNPJ inválido', prefixo);

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, ...pesos1];

    const calcularDigito = (base, pesos) => {
        const soma = base.reduce((acc, num, i) => acc + num * pesos[i], 0);
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const numeros = cleaned.split('').map(Number);
    const base = numeros.slice(0, 12);
    const digito1 = calcularDigito(base, pesos1);
    const digito2 = calcularDigito([...base, digito1], pesos2);

    if (digito1 !== numeros[12] || digito2 !== numeros[13]) {
        return erro('CNPJ inválido', prefixo);
    }

    return ok();
}


function cPF(cpf, prefixo = '') {
    if (!cpf) return erro('CPF não informado', prefixo);

    const cleaned = cpf.replace(/\D/g, '');
    if (cleaned.length !== 11) return erro('CPF deve conter 11 dígitos', prefixo);
    if (/^(\d)\1{10}$/.test(cleaned)) return erro('CPF inválido', prefixo);

    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cleaned.charAt(i), 10) * (10 - i);
    }

    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cleaned.charAt(9), 10)) return erro('CPF inválido', prefixo);

    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cleaned.charAt(i), 10) * (11 - i);
    }

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cleaned.charAt(10), 10)) return erro('CPF inválido', prefixo);

    return ok();
}


function cNPJouCPF(dados, prefixo = '') {
    if (!dados) return erro('CPF/CNPJ não informado', prefixo);

    const cleaned = dados.replace(/\D/g, '');

    if (cleaned.length > 11) {
        return cNPJ(dados, prefixo);
    }

    return cPF(dados, prefixo);
}


function data(dataStr, diasMinimos = 0, prefixo = '') {
    if (!dataStr) return erro('Data não informada', prefixo);

    const dataInformada = Funcoes.parseDataLocal(dataStr);

    if (!dataInformada || isNaN(dataInformada.getTime())) {
        return erro('Data inválida', prefixo);
    }

    dataInformada.setHours(0, 0, 0, 0);

    const dataLimite = new Date();
    dataLimite.setHours(0, 0, 0, 0);
    dataLimite.setDate(dataLimite.getDate() + diasMinimos);

    if (dataInformada < dataLimite) {
        return erro(`A data deve ser igual ou superior a ${Funcoes.formatDate(dataLimite)}`, prefixo);
    }

    return ok();
}


function dataNoMes(dataStr, anomes, prefixo = '') {
    if (!dataStr) return erro('Data não informada', prefixo);

    const data = Funcoes.parseDataLocal(dataStr);

    if (!data || isNaN(data.getTime())) {
        return erro('Data inválida', prefixo);
    }

    const ano = data.getFullYear();
    const mes = data.getMonth() + 1;
    const anomesData = ano * 100 + mes;

    if (anomesData !== anomes) {
        return erro('Data não corresponde ao período informado.', prefixo);
    }

    return ok();
}


function intervaloDatas(startDate, endDate, obrigatorioDatas = true, prefixo = '') {
    if (!startDate || !endDate) {
        if (obrigatorioDatas) return erro('Necessário informar ambas as datas.', prefixo);
        return ok();
    }

    const dataInicio = new Date(startDate);
    const dataFim = new Date(endDate);

    if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
        return erro('Datas inválidas. Verifique o formato das datas.', prefixo);
    }

    if (dataFim < dataInicio) {
        return erro('A data final deve ser maior ou igual à data inicial.', prefixo);
    }

    return ok();
}


function hora(valor, prefixo = '') {
    if (!valor) return erro('Hora não informada', prefixo);

    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(valor)) return erro('Informe corretamente a hora', prefixo);

    return ok();
}


function email(valor, prefixo = '') {
    if (!valor || String(valor).trim() === '') {
        return erro('E-mail não informado', prefixo);
    }

    const emailLimpo = String(valor).trim();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!regex.test(emailLimpo)) {
        return erro('E-mail inválido', prefixo);
    }

    return ok();
}


function telefone(valor, prefixo = '') {
    if (!valor || String(valor).trim() === '') {
        return erro('Telefone não informado', prefixo);
    }

    const cleaned = String(valor).replace(/\D/g, '');

    if (cleaned.length < 10 || cleaned.length > 11) {
        return erro('Telefone inválido', prefixo);
    }

    return ok();
}


export const Validar = {
    ok,
    erro,
    obrigatorio,
    texto,
    numeroPositivo,
    lista,
    id,
    cNPJ,
    cPF,
    cNPJouCPF,
    data,
    dataNoMes,
    intervaloDatas,
    hora,
    email,
    telefone,
};